import { Sparkle } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/site";

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-sky-200 bg-sky-100/80 py-4" aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-8 pr-8">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 whitespace-nowrap">
            <span className="font-display text-lg sm:text-xl text-slate-700 italic">{item}</span>
            <Sparkle className="h-4 w-4 text-sky-400" />
          </span>
        ))}
      </div>
    </div>
  );
}
